<template>
    <div class="demand-task-row mb-3">
        <div class="flex items-start justify-between w-full">
            <div class="mr-3">
                <div class="flex items-center mb-1.5">
                    <div class="creator-cube" :style="{ backgroundColor: task.user.color && task.user.color.includes('#') && task.user.color.length === 7 ? task.user.color : '#000000' }"></div>
                    <span class="ml-2 leading-none font-medium">{{ task.user.first_name }}</span>
                    <span class="ml-2 leading-none">|</span>
                    <span class="ml-2 leading-none">{{ task.task_type.name }}</span>
                    <template v-if="!task.is_done && !taskValidation.canValidate">
                        <span class="ml-2 leading-none">|</span>
                        <span class="ml-2 leading-none italic">Seul {{ task.user.first_name }} peut gérer cette action</span>
                    </template>
                    <span class="ml-1 leading-none">
                        (créée par {{ task.creator.first_name }}{{ task.modifier ? ' - modifiée par ' + task.modifier.first_name : null }})
                    </span>
                </div>
                <p class="leading-4">
                    <span class="underline">Commentaire :</span>
                    {{ task.text ? task.text : 'Ø' }}
                </p>
            </div>
            <div class="flex items-center">
                <div v-if="canEdit && !task.is_done">
                    <md-button class="md-icon-button md-raised md-warning my-0" @click="updating = true">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
                    </md-button>
                    <md-tooltip md-direction="top">Modifier</md-tooltip>
                </div>
                <div v-if="taskValidation.canValidate && !task.is_done" class="ml-1">
                    <md-button class="md-icon-button md-raised md-info my-0" @click="taskValidation.showValidation = true">
                        <font-awesome-icon class="md-icon" :icon="['fa', 'cog']" />
                    </md-button>
                    <md-tooltip md-direction="top">Traiter l'action</md-tooltip>
                </div>
            </div>
        </div>
        <div v-if="taskValidation.canValidate && taskValidation.showValidation && !task.is_done" class="mt-1">
            <p class="font-medium">Traitement</p>
            <div class="flex items-center w-full">
                <div class="w-full">
                    <md-field class="md-invalid">
                        <label>Texte</label>
                        <md-textarea v-model="taskValidation.text" name="comment" md-autogrow></md-textarea>
                        <validation-error :errors="apiValidationErrors.comment" />
                    </md-field>
                </div>
                <div class="flex items-center ml-3">
                    <div class="mr-1">
                        <md-button class="md-icon-button md-raised md-danger my-0" @click="resetValidateTask">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                        </md-button>
                        <md-tooltip md-direction="top">Annuler</md-tooltip>
                    </div>
                    <div>
                        <md-button class="md-icon-button md-raised md-success my-0" @click="validateTask">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'check']" />
                        </md-button>
                        <md-tooltip md-direction="top">Fait</md-tooltip>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="updating" class="mt-3">
            <div class="flex items-start w-full">
                <div class="w-full">
                    <div class="flex items-center w-full">
                        <div class="md-multiselect w-1/3">
                            <label>Utilisateur </label>
                            <multiselect
                                v-model="edit.user"
                                :options="users"
                                placeholder=""
                                :option-height="104"
                                track-by="id"
                                label="first_name"
                                openDirection="bottom"
                                :show-labels="false">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                        <div class="md-multiselect w-1/3">
                            <label>Type de demande </label>
                            <multiselect
                                v-model="edit.demandType"
                                :options="demandTypes"
                                placeholder=""
                                :option-height="104"
                                track-by="id"
                                label="name"
                                openDirection="bottom"
                                :show-labels="false">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="w-full mt-2">
                        <md-field class="md-invalid">
                            <label>Texte</label>
                            <md-textarea v-model="edit.text" name="text" md-autogrow></md-textarea>
                            <validation-error :errors="apiValidationErrors.text" />
                        </md-field>
                    </div>
                </div>
                <div class="flex items-center mt-2">
                    <div class="mr-1">
                        <md-button class="md-icon-button md-raised md-danger my-0" @click="updating = false">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'times']" />
                        </md-button>
                        <md-tooltip md-direction="top">Annuler</md-tooltip>
                    </div>
                    <div>
                        <md-button class="md-icon-button md-raised md-success my-0" @click="updateTask">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'check']" />
                        </md-button>
                        <md-tooltip md-direction="top">Enregistrer</md-tooltip>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { mapState } from "vuex";

export default {
    name: "DemandTaskRow",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        task: Object,
        demandId: Number,
        canEdit: Boolean
    },
    data() {
        return {
            updating: false,
            edit: {
                user: null,
                demandType: null,
                text: null
            },
            users: [],
            demandTypes: [],
            taskValidation: {
                canValidate: false,
                showValidation: false,
                text: null
            },
        }
    },
    computed: mapState({
        user: state => state.profile.me,
    }),
    methods: {
        async getUsers() {
            const { data } = await this.$store.dispatch('users/fetchActive')
            this.users = data
        },
        async getDemandTypes() {
            const { data } = await this.$store.dispatch('demandTypes/getDemandTypes')
            this.demandTypes = data
        },
        async updateTask() {
            this.resetApiValidation()
            try {
                await this.$store.dispatch('demandTasks/updateDemandTask', {
                    demandTaskId: this.task.id,
                    text: this.edit.text,
                    user_id: this.edit.user.id,
                    type_id: this.edit.demandType.id
                })
                await this.$store.dispatch('alerts/success', 'Action modifiée')
                this.updating = false
                this.$emit('updated')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        async validateTask() {
            this.resetApiValidation()
            let comment = 'La tâche de ' + this.task.user.first_name + ' est réalisée.'
            if(this.taskValidation.text) comment = comment + '\nMessage : ' + this.taskValidation.text
            try {
                await this.$store.dispatch('demandComments/addDemandComment', {
                    demand_id: this.demandId,
                    comment: comment,
                    task_id: this.task.id
                })
                await this.$store.dispatch('alerts/success', 'Action traitée')
                this.$emit('task-validate')
            } catch (e) {
                this.setApiValidation(e.response.data.errors)
            }
        },
        setupData() {
            this.edit = {
                user: _.cloneDeep(this.task.user),
                demandType: _.cloneDeep(this.task.task_type),
                text: _.cloneDeep(this.task.text)
            }
        },
        checkUserId() {
            this.taskValidation.canValidate = parseInt(this.user.id) === parseInt(this.task.user_id)
        },
        resetValidateTask() {
            this.taskValidation = {
                ...this.taskValidation,
                showValidation: false,
                text: ''
            }
        },
    },
    mounted() {
        this.setupData()
        this.checkUserId()
    },
    watch: {
        task() {
            this.setupData()
            this.checkUserId()
        },
        updating(newVal) {
            if(newVal) {
                this.getUsers()
                this.getDemandTypes()
            }
        },
        user() {
            this.checkUserId()
        }
    }
}
</script>

<style scoped lang="scss">
.creator-cube {
    width: 12px;
    height: 12px;
    border-radius: 3px;
}
.md-multiselect:first-child {
    margin-right: 2rem;
}
.demand-task-row {
    &:last-child {
        margin-bottom: 0 !important;
    }
}
</style>
